import React, {Component, useState} from "react";
import {Form, Loader, Message} from 'semantic-ui-react'
import {SuccessMessage} from "../_core/SuccessMessage";

export default function OperatingCostsNew(props) {
    const today = new Date()
    const today_date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    const [data, setData] = useState({
        date: today_date,
        total: '',
        note: '',
        message: undefined,
        loading: false,
    });

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setData({...data, [name]: value});
    }

    const handleSubmit = () => {
        const url = API_URL + '/api/private/tanker/v1/operating-costs'
        const body = JSON.stringify({
            date: data.date,
            total: data.total,
            note: data.note
        })

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: body
        })
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({message: data, loading: false});
            });

    }
    const {message} = data;
    return (
        <div>
            <h2>New </h2>
            <p>Create new operating costs</p>
            <Form>
                <Form.Group widths='equal'>
                    <Form.Input label="Date" name="date" placeholder="" value={data.date}
                                onChange={handleInputChange}/>
                    <Form.Input label="Total" name="total" placeholder="" value={data.total}
                                onChange={handleInputChange}/>
                    <Form.Input label="Note" name="note" placeholder="" value={data.note}
                                onChange={handleInputChange}/>
                </Form.Group>
                <Form.Button onClick={handleSubmit}>Submit</Form.Button>
            </Form>
            {data.loading ? <Loader active inline='centered'></Loader> : ''}
            {typeof message !== 'undefined' ?
                <SuccessMessage header="Success" message="Operating Cost created"/> : ''}
        </div>
    )
}


